import type { SignUpRequest, SignUpResponse } from '@/types/api';
import type { UserProfile } from '@/types/user';
import { apiGet, apiPost, apiPatch } from './client';

export async function signUp(
  data: SignUpRequest,
  getToken?: () => Promise<string | null>
): Promise<SignUpResponse> {
  return apiPost<SignUpResponse>('/api/auth/signup', data, getToken);
}

/**
 * Get user profile with stats
 */
export async function getUserProfile(
  getToken?: () => Promise<string | null>
): Promise<UserProfile> {
  return apiGet<UserProfile>('/api/user/profile', getToken);
}

/**
 * Update user profile (gamertag, avatar)
 */
export async function updateUserProfile(
  data: { gamertag?: string; avatarId?: string },
  getToken?: () => Promise<string | null>
): Promise<{ user: UserProfile; message?: string }> {
  return apiPatch<{ user: UserProfile; message?: string }>(
    '/api/user/profile',
    data,
    getToken
  );
}

